import type { FC } from 'react'

import type { Locale } from '@skytech/types'
import { twJoin } from 'tailwind-merge'

import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

export const FormattedNumberWithCurrency: FC<{
  amount: number
  currency?: Intl.NumberFormatOptions['currency']
  locale?: Locale
  precision?: number
  className?: string
  isTextBold?: boolean
  showCurrency?: boolean
  strikeThrough?: boolean
}> = ({
  amount,
  currency,
  locale,
  precision,
  isTextBold,
  showCurrency,
  className,
  strikeThrough,
}) => {
  const { formatNumber } = useFormattedNumberWithCurrency()

  return (
    /* todo: Remove ! when refactored */
    <span
      className={twJoin(isTextBold && '!font-bold', strikeThrough && 'line-through', className)}
    >
      {formatNumber({
        amount: amount || 0,
        locale,
        currency,
        precision,
        showCurrency,
      })}
    </span>
  )
}
